<template>
  <EditableFrame
    class="short-url-visited-wrapper"
    title="Edit Trigger"
    :subtitle="item.name"
    has-save-button
    :save-button-disabled="savedButtonDisabled"
    :block-type="item.type"
    @close="$emit('close')"
    @save="handleSave"
  >
   <ar-text
      class="short-url-heading"
      size="13px"
      text="URL"
      weight="bold"
      multiple-lines
      :max-lines="1"
      letter-spacing="1px"
    />
    <ar-input
      ref="shortURLInput"
      class="short-url-input"
      :style="{
        height: '40px'
      }"
      v-model="inputText"
      @enter="handleSave"
      placeholder="Please enter a URL..."
      auto-focus
    />
  </EditableFrame>
</template>
<script>
import EditableFrame from '../utils/EditableFrame.vue'
import { mapActions } from 'vuex'
export default {
  name: 'shortUrlVisited',
  props: {
    item: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      inputText: ''
    }
  },
  components: {
    EditableFrame,
  },
  watch: {
    'item.id'() {
      this.setItemVals()
    },
  },
  computed: {
    savedButtonDisabled() {
      return !(!!this.inputText)
    }
  },
  methods: {
    ...mapActions({
      updateTriggerContextData: 'automation/UPDATE_TRIGGER_CONTEXT_DATA'
    }),
    handleSave() {
      let contextData = {
        config: {
          'target-url': this.inputText,
        },
      }

      this.updateTriggerContextData({id: this.item.id, data: contextData})
      this.$emit('close')
    },
    resetDefaults() {
      this.inputText = ''
    },
    setItemVals() {
      this.resetDefaults()
      if (this.item.config?.['target-url']) {
        this.inputText = this.item.config['target-url']
        this.$refs.shortURLInput.$el.children[1].blur()
      }
    }
  },
  mounted() {
    this.setItemVals()
  }
}
</script>
<style lang="scss" scoped>
.short-url-visited-wrapper {
  width: 100%;
  height: 100%;

  .short-url-heading {
    margin-bottom: 14px;
  }
}
</style>
